import { useEffect, useRef, useState } from "react";
import { UploadPanel } from "./components/UploadPanel";
import { Viewport } from "./components/Viewport";
import { PropertiesPanel } from "./components/PropertiesPanel";
import { useSceneStore } from "./store/sceneStore";
import { useAutosave } from "./hooks/useAutosave";
import { loadSceneFromIndexedDb } from "./store/persistence";
import { fetchSharedScene } from "./lib/share";

export default function App() {
  const loadScene = useSceneStore((s) => s.loadScene);
  const resetScene = useSceneStore((s) => s.resetScene);
  const objectCount = useSceneStore((s) => s.objects.length);
  const [status, setStatus] = useState<string>("");
  const initialized = useRef(false);

  useAutosave();

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const match = window.location.pathname.match(/^\/s\/([\w-]+)$/);
    if (match) {
      setStatus("Lade geteilte Szene…");
      fetchSharedScene(match[1])
        .then((scene) => {
          loadScene(scene.objects, scene.settings);
          setStatus("Geteilte Szene geladen");
          window.history.replaceState({}, "", "/");
        })
        .catch(() => setStatus("Geteilte Szene konnte nicht geladen werden"))
        .finally(() => window.setTimeout(() => setStatus(""), 3000));
      return;
    }

    loadSceneFromIndexedDb().then((persisted) => {
      if (persisted && persisted.objects.length > 0) {
        loadScene(persisted.objects, persisted.settings);
      }
    });
  }, [loadScene]);

  return (
    <div className="app-layout">
      <header className="app-header">
        <h1>FORMWERK</h1>
        <span style={{ flex: 1 }} />
        {status && <span style={{ fontSize: 12, color: "var(--text-dim)" }}>{status}</span>}
        <button
          disabled={objectCount === 0}
          onClick={() => {
            if (window.confirm("Aktuelle Szene wirklich löschen?")) resetScene();
          }}
        >
          Neue Szene
        </button>
      </header>
      <UploadPanel />
      <Viewport />
      <PropertiesPanel />
    </div>
  );
}
